export default __webpack_public_path__ + "static/media/voice.7bb4db0f.svg";